import * as types from "../mutation-types";
import {
    processAPIReinvestSetting,
    processAPISubSequentSetting,
    processAPIRebalanceSetting,
    processAPITaxSetting,
    processAPIFeeSetting,
    processAPIBenchmarkSetting
} from "../defaultPreferenceHelpers";

const state = {
    languageId: "en-US",
    currency: "USD",
    timePeriod: 1,
    allocateBy: 0,
    initialInvestmentAmount: 10000,
    reportCover: {},
    reportGeneral: {},
    reportOptions: [],
    taxSetting: {},
    feeSetting: {},
    rebalanceSetting: null,
    benchmarkSetting: {},
    reinvestSetting: null,
    subSequentSetting: null
};

const actions = {
    setPreference({ commit, dispatch }, data) {
        const { general, portfolio, hypothetical, reportCover, reportGeneral } = data;
        commit(types.SET_LANGUAGE_ID, general.language);
        commit(types.SET_CURRENCY, general.currency);
        commit(types.SET_REPORT_COVER_PREFERENCE, reportCover);
        commit(types.SET_REPORT_GENERAL_PREFERENCE, reportGeneral);
        commit(types.SET_REPORT_OPTIONS, hypothetical.reportOptions);
        commit(types.SET_TIME_PERIOD, Number(hypothetical.timePeriod));
        commit(types.SET_ALLOCATE_BY, portfolio.portfolioAllocation.allocateBy);
        commit(types.SET_INITIAL_INVESTMENT_AMOUNT, portfolio.portfolioAllocation.initialInvestment);
        commit(types.SET_TAX_SETTING, processAPITaxSetting(hypothetical.taxSetting));
        commit(types.SET_FEE_SETTING, processAPIFeeSetting(portfolio.feeSetting));
        commit(types.SET_REBALANCE_SETTING, processAPIRebalanceSetting(hypothetical.rebalanceSetting));
        commit(types.SET_BENCHMARK_SETTING, processAPIBenchmarkSetting(hypothetical.benchmarkSetting));
        commit(types.SET_REINVESTMENT_SETTING, processAPIReinvestSetting(hypothetical.reinvestSetting));
        commit(types.SET_SUB_SEQUENT_SETTING, processAPISubSequentSetting(hypothetical.subSequentSetting));
        dispatch("hypo/updateStateByPreference", data, { root: true });
        dispatch("reportSetting/setReportCoverSetting", reportCover, { root: true });
        dispatch("reportSetting/setReportGeneralSetting", reportGeneral, { root: true });
        return dispatch("reportSetting/loadReportSetting", hypothetical.reportOptions, { root: true });
    }
};

const getters = {
    getPreferenceSettings(state) {
        return {
            currency: state.currency,
            allocateBy: state.allocateBy,
            securities: state.securities || [],
            transfers: state.transfers || [],
            rebalance: state.rebalanceSetting || {},
            feeSetting: state.feeSetting,
            taxSetting: state.taxSetting,
            benchmark: state.benchmarkSetting,
            reinvestSetting: state.reinvestSetting || {},
            subSequentSetting: state.subSequentSetting || {},
            date: state.date || {}
        };
    }
};

const mutations = {
    [types.SET_LANGUAGE_ID](state, data) {
        state.languageId = data;
    },
    [types.SET_CURRENCY](state, data) {
        state.currency = data;
    },
    [types.SET_TIME_PERIOD](state, data) {
        state.timePeriod = data;
    },
    [types.SET_BENCHMARK_SETTING](state, data) {
        state.benchmarkSetting = data;
    },
    [types.SET_ALLOCATE_BY](state, data) {
        state.allocateBy = data;
    },
    [types.SET_INITIAL_INVESTMENT_AMOUNT](state, data) {
        state.initialInvestmentAmount = data;
    },
    [types.SET_REPORT_COVER_PREFERENCE](state, data) {
        state.reportCover = data;
    },
    [types.SET_REPORT_GENERAL_PREFERENCE](state, data) {
        state.reportGeneral = data;
    },
    [types.SET_REPORT_OPTIONS](state, data) {
        state.reportOptions = data;
    },
    [types.SET_TAX_SETTING](state, data) {
        state.taxSetting = data;
    },
    [types.SET_FEE_SETTING](state, data) {
        state.feeSetting = data;
    },
    [types.SET_REBALANCE_SETTING](state, data) {
        state.rebalanceSetting = data;
    },
    [types.SET_REINVESTMENT_SETTING](state, data) {
        state.reinvestSetting = data;
    },
    [types.SET_SUB_SEQUENT_SETTING](state, data) {
        state.subSequentSetting = data;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
